module.exports = __webpack_public_path__ + "img/JE.9dc9ba70.svg";